<script setup></script>
<template>
    <i class="fa-solid fa-pen-to-square"></i>
</template>
